import { Copy, Danger, Import, ImportCurve, Printer, Refresh } from "iconsax-reactjs";
import { Download } from "lucide-react";

const BackupCodesModal = ({
    isOpen,
    backupCodes,
    hasSavedBackupCodes,
    onClose,
    onCopy,
    onDownload,
    onPrint,
    onRegenerate,
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[300] flex items-center justify-center bg-black bg-opacity-50 px-4 py-8">
            <div className="w-full max-w-[650px] overflow-hidden rounded-2xl bg-white shadow-lg">
                <div className="flex items-start justify-between gap-6 p-8 pb-6">
                    <div>
                        <h3 className="heading-h2-semibold text-[#101828]">
                            Save your backup codes
                        </h3>
                        <p className="mt-2 aku-body-small-regular text-[#667085]">
                            If you lose access to your authenticator app, you can use the recovering
                            codes below to get back into your Tradevu admin account
                        </p>
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={!hasSavedBackupCodes}
                        className={`text-3xl text-[#292D32] ${
                            !hasSavedBackupCodes ? "cursor-not-allowed opacity-40" : ""
                        }`}
                    >
                        ×
                    </button>
                </div>

                <div className="px-8">
                    <div className="rounded-xl bg-[#F9FAFB] px-6 py-6">
                        <div className="grid grid-cols-2 gap-x-6 gap-y-5 aku-body-small-medium text-[#101828] md:grid-cols-3">
                            {backupCodes.map((code, index) => (
                                <p key={`${code}-${index}`}>{code}</p>
                            ))}
                        </div>
                    </div>

                    <div className="mt-6 flex flex-wrap gap-3">
                        <button
                            type="button"
                            onClick={onCopy}
                            className="rounded-lg border flex gap-2 items-center border-[#EAECF0] bg-white !px-5 !py-2 text-sm font-medium text-[#344054]"
                        >
                            <Copy variant="Bold" size={20} />
                            Copy
                        </button>
                        <button
                            type="button"
                            onClick={onDownload}
                            className="rounded-lg border flex gap-2 items-center border-[#EAECF0] bg-white !px-5 !py-2 text-sm font-medium text-[#344054]"
                        >
                            <ImportCurve variant="Bold" size={20} />
                            Download
                        </button>
                        <button
                            type="button"
                            onClick={onPrint}
                            className="rounded-lg border flex gap-2 items-center border-[#EAECF0] bg-white !px-5 !py-2 text-sm font-medium text-[#344054]"
                        >
                            <Printer variant="Bold" size={20} />
                            Print
                        </button>
                        <button
                            type="button"
                            onClick={onRegenerate}
                            disabled
                            className="rounded-lg border flex gap-2 items-center border-[#EAECF0] bg-white !px-5 !py-2 text-sm font-medium text-[#344054]"
                        >
                            <Refresh variant="Bold" size={20} />
                            Regenerate
                        </button>
                    </div>

                    <div className="mt-6 flex items-start gap-1 pb-6 text-[#667085]">
                        <Danger variant="Bold" color="#6F739B" />
                        <p className="aku-body-small-regular">
                            Keep these codes safe and don&apos;t share them. They can only be used
                            once, and you won&apos;t see them again for security reasons.
                        </p>
                    </div>
                </div>

                <div className="border-t border-[#EAECF0] bg-[#F9FAFB] px-8 py-4 aku-body-small-regular italic text-[#667085]">
                    You can only close this modal after downloading or copying the codes
                </div>
            </div>
        </div>
    );
};

export default BackupCodesModal;
